import axios from 'axios';
import * as endpoint from '../../../endpoint';

import {
  checkCancelToken,
  consolelog,
  delCancelToken,
} from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';
import { SUCCESS_API_CREATE_REPORT } from '../../../actionTypes';
import { ReportStatus } from '../../../../components/ReportEdit/TitleArea';

/**
 * 下書き状態の報告書を新規作成する。
 * 取得したデータは、reduxで管理する。
 *
 * @param {string} apiToken - APIトークン
 * @param {string} groupId - グループID。このグループに紐づく報告書一覧を取得する。
 * @param {string} reportTitle - 報告書のタイトル。
 * @param {string} createDate - 報告書の作成日時。
 * @returns {Function} dispatch - Redux dispatch関数
 */
const createReport =
  (apiToken, groupId, reportTitle, createDate) => dispatch => {
    consolelog('[API CALL] createReport()', apiToken);
    configureAxiosForJSON(apiToken);
    const { cancelToken, cancelTokenKey } = createCancelToken('createReport');
    const url = endpoint.API_CREATE_REPORT.replace('{groupId}', groupId);

    const params = {
      cancelToken,
      status: ReportStatus.create,
      layoutType: 1, // 現状は1固定
      frames: [],
      name: reportTitle,
      createDate,
    };
    return axios
      .post(url, params)
      .then(res => {
        if (checkCancelToken(cancelTokenKey)) {
          dispatch({
            type: SUCCESS_API_CREATE_REPORT,
            payload: res.data,
          });
        }
        delCancelToken(cancelTokenKey);
      })
      .catch(thrown => {
        if (!axios.isCancel(thrown)) {
          handleErrorResponse(thrown, dispatch);
        }
        delCancelToken(cancelToken);
      });
  };

export default createReport;
